import { apiFetch } from "./api.js";

/** List applications with optional status filter + pagination */
export async function listApplications({ status, limit = 20, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (status) params.set("status", status);
  return apiFetch(`/api/admin/applications?${params}`);
}

/** Get pending application count (for sidebar badge) */
export async function getPendingCount() {
  return apiFetch("/api/admin/applications/count?status=pending_approval");
}

/** Get single application detail */
export async function getApplicationDetail(id) {
  return apiFetch(`/api/admin/applications/${id}`);
}

/** Approve an application */
export async function approveApplication(id) {
  return apiFetch(`/api/admin/applications/${id}/approve`, { method: "POST" });
}

/** Reject an application with reason */
export async function rejectApplication(id, reason) {
  return apiFetch(`/api/admin/applications/${id}/reject`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}

/** Invite a candidate email to manage a persona */
export async function invitePersonaOwner(email, personaId) {
  return apiFetch("/api/admin/invite-persona-owner", {
    method: "POST",
    body: JSON.stringify({ email, persona_id: personaId }),
  });
}
